const format = (value: number) => new Intl.NumberFormat('cs-CZ').format(Math.round(value || 0));

export function NgrRoiCard({ value, currency }: { value: number | null; currency: string }) {
  const tone = value == null ? 'neutral' : value >= 100 ? 'strong' : value >= 0 ? 'healthy' : 'low';
  const label = value == null ? 'Bez dat' : value >= 100 ? 'Silný výkon' : value >= 0 ? 'Zisk po odměnách' : 'Odměny převyšují NGR';
  const progress = value == null ? 0 : Math.max(0, Math.min(100, (value + 100) / 3));
  return (
    <section className={`prototype-roi-card is-${tone}`} aria-label={`NGR ROI ${value == null ? 'bez dat' : `${value} procent`}`}>
      <div className="prototype-roi-copy"><span>NGR ROI <i>·</i> {currency}</span><strong>{value == null ? '–' : `${format(value)} %`}</strong><small>{label}</small></div>
      <div className="prototype-roi-visual">
        <div className="prototype-roi-scale"><span>−100</span><span>0</span><span>200+</span></div>
        <div className="prototype-roi-track"><span className="prototype-roi-target" /><span className="prototype-roi-fill" style={{ width: `${progress}%` }}><i /></span></div>
      </div>
    </section>
  );
}
